import { useEffect, useState } from "react";
import { Content } from "./PartDetails.style";
import { useParams } from "react-router";
import { Container } from "@mui/material";
import ServiceProvider from "../../../configuration/ServiceProvider";
import { PartDetails } from "../../../../explorer/types/SpareParts/PartDetails";
import DrawerSkeleton from "../PartDetailsSkeleton";
import PartHeader from "./PartDetailsHeader";
import PartDetailsInfo from "./PartDetailsInfo";
import PartDetailsTabs from "./PartDetailsTabs";
import useLanguages from "../../../../explorer/hooks/useLanguages";

const PartDetailsPage = () => {
    const { brand, partCode } = useParams();

    const [loading, setLoading] = useState<boolean>(true);
    const [partDetails, setPartDetails] = useState<PartDetails>();

    const { currentLanguage } = useLanguages();

    useEffect(() => {
        setLoading(true);

        if (brand !== undefined && partCode !== undefined)
            ServiceProvider.SpareParts.getPartDetails(
                brand,
                partCode,
                currentLanguage
            )
                .then((result) => {
                    setPartDetails(result);
                    setLoading(false);
                })
                .catch((error) => console.error(error));
    }, []);

    return !loading && partDetails !== undefined ? (
        <Content>
            <PartHeader {...partDetails} />
            <Container maxWidth="md">
                <PartDetailsInfo {...partDetails} />
                <PartDetailsTabs {...partDetails} />
            </Container>
        </Content>
    ) : (
        <Container>
            <DrawerSkeleton />
        </Container>
    );
};

export default PartDetailsPage;
